<template>
    <div class="form-group">
        <label class="form__label up">Imagens</label>
        <table>
            <thead>
                <tr>
                    <th></th><th>Imagem</th>
                </tr>
            </thead>
            <tbody v-if="!loading">
                <template v-for="(image, index) in snap.photos">
                    <image-file :featured="false" :image="image" :list="select" :do-list="doList" :index="index" :key="index" :callback="updateImage"></image-file>
                </template>
            </tbody>
        </table>
        <div class="flex-between">
            <button v-if="select.length" type="button" class="button white button-small" @click="removeImages()"><i class="ico-delete_outline"></i> Excluir <template v-if="select.length > 1"> {{ select.length }} fotos selecionadas</template><template v-if="select.length == 1">foto selecionada</template></button>
            <span v-else></span>
            <button type="button" class="button white button-small" @click="addImage()"><i class="ico-add_a_photo"></i> Incluir foto</button>
        </div>
    </div>
</template>
<script>
import ImageFile from '../Machines/Image'
export default {
    name: "IndustryForm",
    components: {
        ImageFile
    },
    data(){
        return {
            loading: false,
            select: []
        }
    },
    props: {
        snap: {
            type: [Object, Array]
        }
    },
    methods: {
        removeImages(){
            this.loading = true
            this.select.forEach((it) => {
                this.snap.photos.splice(it, 1)
            })
            this.select = []
            this.loading = false
        },
        doList(index){
            console.log('Changing ' + index)
            this.loading = true
            if(this.select.includes(index)){
                this.select.splice(index, 1)
            }
            else{
                this.select.push(index)
            }
            this.loading = false
        },
        updateImage(img, index){
            this.snap.photos[index] = img
        },
        addImage(){
            this.loading = true
            this.snap.photos.push({
                // docId:"EWU5cQJBB6g5LeZWxw4Z",
                // lastModified:1616988327584,
                // name:"VCG.jpg",
                // size:2046367,
                // type:"image/jpeg",
                // updatedOn:"1617002967",
                // url:"https://firebasestorage.googleapis.com/v0/b/vacuum-center.appspot.com/o/VCG.jpg?alt=media&token=dee392a4-7ec9-4ddf-acc8-74181e759f6b"

            })
            setTimeout(()=>{
                this.loading = false
            },100)
        },
    }
}
</script>